module.exports = __webpack_public_path__ + "static/facebookpage_bg-62e61b62e873dde126b23ea5a349435c.jpg";